import React from "react";
import WithdrawItems from "./items";
import Layout from "../layout/layout";
import Search from "./search";
import "./withdraw.css";







const Withdraw = () => {




    return (
        <Layout>
            <div className="withraw-page">

                <Search />

                <WithdrawItems/>


            </div>
     
        </Layout>
    );
};

export default Withdraw;